import React from 'react';

/** *********************** COMPONENTS  ********************8 */
import { Box, Text, useDisclosure,Select } from '@chakra-ui/react';
import Card from 'components/Cards/Card';
// import CustomTable from 'components/Table/CustomTable';
import Companyactionmodel from 'components/Model/Companyactionmodel';
import CustomPaginationTable from 'components/Table/CustomPaginationTable';
import FilterSearchBar from '../User/components/FilterSearchBar';
/** *********************** HELPERS  **********************8 */
import { getCompanyTableHeader } from 'components/Table/Headers/Company/companyTableHeader';
import { useLazyGetApprovalsQuery } from 'reducers/company.service';
import { APPROVE_ACTION , REJECTE_ACTION } from 'constants/admin-actions';
import { useSearchParamsHook } from 'hooks/index';
const ApproveButton = ()=>{
    return (
        <Text color={'green'} colorScheme='brand'>
            Approve
        </Text>
    );
};
const RejectButton = ()=>{
    return (
        <Text colorScheme='red' color='red'>
            Reject
        </Text>
    );
};

const Approvals = ()=>{
    const companymodelUtil = useDisclosure();
    const { onOpen } = companymodelUtil;
    const [getApprovals, { refetch,isLoading, isError, data }] = useLazyGetApprovalsQuery();
    const [searchparams , setSearchParams] = useSearchParamsHook();
    const ByType = searchparams.get('type') || '';
    const ByStatus = searchparams.get('status') || '';

    const [row , setrow] = React.useState(null);
    const [Action , setAction] = React.useState(APPROVE_ACTION);

    const handleAction = (ACTION , rowdata)=>{
        setAction(ACTION);
        setrow(rowdata);
        onOpen();
    };
    const onApproveCompany = (rowdata)=>{
        handleAction(APPROVE_ACTION, rowdata);
    };
    const onRejectCompany = (rowdata)=>{
        handleAction(REJECTE_ACTION , rowdata);
    };
    const handlePageChange = (query)=>{
        return getApprovals(query).unwrap();
    };
    const handleStatusChange = (e)=>{
        let { name, value } = e.target;
        setSearchParams(name , value);
    };

    const companyTableHeader = getCompanyTableHeader({ tableActions: [{ label: 'Approve', icon: <ApproveButton /> ,onClick: onApproveCompany },{ label: 'Reject', icon: <RejectButton /> ,onClick: onRejectCompany }] });
    return (
        <Box pt={{ base: '130px', md: '80px', xl: '65px' }}>
            <Companyactionmodel ACTION={Action} row={row} setrow={setrow} {...companymodelUtil} />
            <Card>
                <FilterSearchBar
                    onRefresh={refetch}
                    isApprovalFilter={false}
                    isProfileFilter={false}
                    isDateFilter={false}
                    isStatus={false}
                    downloadType={'APPROVALS'}
                    isPercentage={false}
                    isApprovalStatusFilter = {true}
                >
                    <Select
                        placeholder="Status (All)"
                        fontWeight="semibold"
                        size="sm"
                        w="150px"
                        name='status'
                        onChange={handleStatusChange}
                        value={ByStatus}
                    >
                        <option value="APPROVED">Approved</option>
                        <option value="REJECTED">Rejected</option>
                        <option value="PENDING">Pending</option>
                    </Select>
                    <Select
                        placeholder="Type (All)"
                        fontWeight="semibold"
                        size="sm"
                        w="150px"
                        name='type'
                        onChange={handleStatusChange}
                        value={ByType}
                    >
                        <option value="EDITABLE">Editable</option>
                        <option value="APPROVAL">Approval</option>
                    </Select>

                </FilterSearchBar>

                <div className="page-main-box">
                    <CustomPaginationTable
                        {...data}
                        handlePageChange={handlePageChange}
                        handleRefresh={refetch}
                        columns={companyTableHeader}
                        isLoading={isLoading}
                        isError={isError}
                    />
                    {/* <CustomTable
                        handleRefresh={refetch}
                        data={data}
                        columns={companyTableHeader}
                        isLoading={isLoading}
                        isError={isError}
                        defaultSorted={[{ dataField: 'status',order: 'asc' }]}
                        key="_id"
                    /> */}
                </div>
            </Card>
        </Box>
    );
};

export default Approvals;
